module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="followMainAlarm-slider"><label for="follow-main-alarm-enabled">{{ tc(\'ControlHomeAlerts\', \'Follow Main Alarm:\') }}</label><div class="input" id="follow-main-alarm-enabled"><defa-radio-strip v-model="followMainAlarmSwitchValue" :options="actionOptions" v-bind:class="{ errorState: followMainAlarmSwitchDisabled}" v-on:input="save($event, \'followMainIntrusionAlarmSwitch\')"></div><dl v-show="model.followMainIntrusionAlarmSwitchError"><dd><p class="error">ERROR! {{ model.followMainIntrusionAlarmSwitchError }}</p></dd></dl></div>';
}
return __p;
};
